import { render } from "./BlockStudents.vue?vue&type=template&id=22ce3a04&scoped=true"
import script from "./BlockStudents.vue?vue&type=script&lang=js"
export * from "./BlockStudents.vue?vue&type=script&lang=js"

import "./BlockStudents.vue?vue&type=style&index=0&id=22ce3a04&scoped=true&lang=css"
import "./BlockStudents.vue?vue&type=style&index=1&id=22ce3a04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ce3a04"]])

export default __exports__